import { useEffect, useRef } from 'react';
import { authService } from '../api/authService';
import api from '../api/api';

const STORAGE_KEY = 'lastUserValidityCheck';
const KICK_POLL_MS = 30_000; // 30 secondi

export async function validateSession(): Promise<void> {
  if (!authService.isAuthenticated()) return;
  try {
    await api.get('/auth/validate');
    console.debug('[useUserValidityCheck] validate OK');
  } catch (err: any) {
    console.debug('[useUserValidityCheck] validate FAILED', err?.response?.status);
    if (err?.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEY);
      // Il 401 interceptor in api.ts fa già redirect a /login
    }
  }
}

export function useUserValidityCheck() {
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!authService.isAuthenticated()) return;

    // Controlla subito all'avvio
    validateSession();

    // Poi ogni 30s come fallback
    intervalRef.current = window.setInterval(validateSession, KICK_POLL_MS);

    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, []);
}

